/**
 * Compara valores sem coerção, incluindo valores falsy válidos.
 *
 * @param {*} pLeft
 * @param {*} pRight
 * @returns {boolean}
 */
export const isSameValue = (pLeft, pRight) => Object.is(pLeft, pRight);

/**
 * Verifica se uma lista contém o valor informado sem coerção.
 *
 * @param {Array<*>} pValues
 * @param {*} pValue
 * @returns {boolean}
 */
export const includesValue = (pValues, pValue) =>
  pValues.some((pItem) => isSameValue(pItem, pValue));

/**
 * Codifica o ID estável de uma opção para os controles HTML.
 *
 * @param {string|number} pId
 * @returns {string}
 */
export const getOptionControlValue = (pId) => `${typeof pId}:${String(pId)}`;
